import { maskPhone } from "@/lib/api";

function ClockAnim() {
  return (
    <div className="relative mx-auto h-24 w-24" data-testid="boy-courier-clock">
      <span className="absolute inset-0 animate-ping rounded-full bg-primary/15" style={{ animationDuration: "2.4s" }} />
      <svg viewBox="0 0 64 64" className="relative h-24 w-24 text-primary" fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" aria-hidden="true">
        <circle cx="32" cy="32" r="27" className="fill-background" />
        <line x1="32" y1="32" x2="32" y2="17" className="animate-spin" style={{ transformOrigin: "32px 32px", animationDuration: "12s" }} />
        <line x1="32" y1="32" x2="43" y2="32" className="animate-spin" style={{ transformOrigin: "32px 32px", animationDuration: "2s" }} />
        <circle cx="32" cy="32" r="2.5" fill="currentColor" />
      </svg>
    </div>
  );
}

export function Waiting({ phone }) {
  return (
    <div className="card-surface fade-up space-y-5 p-6 text-center sm:p-8" data-testid="boy-courier-done">
      <ClockAnim />
      <h1 className="text-2xl font-bold leading-tight">Tudo pronto! Recebemos seu cadastro.</h1>
      <p className="inline-flex items-center gap-2 rounded-full bg-amber-500/15 px-3 py-1.5 text-sm font-semibold text-amber-700 dark:text-amber-300" data-testid="boy-courier-review-status">
        <span className="h-2 w-2 animate-pulse rounded-full bg-amber-500" />Em análise de segurança e vagas.
      </p>
      <p className="text-sm text-muted-foreground">
        Verificamos a quantidade de entregadores na sua região para garantir que haja pedidos suficientes para todos.
        Avisaremos você pelo WhatsApp{phone ? ` ${maskPhone(phone)}` : ""} assim que sua conta for liberada.
      </p>
    </div>
  );
}
